module.exports = __webpack_public_path__ + "img/ankle-after-roll.1b2df338.svg";